export const FETCH_JOB_LIST = 'FETCH_JOB_LIST';
export const FETCH_JOB_LIST_SUCCESS = 'FETCH_JOB_LIST_SUCCESS';
export const FETCH_JOB_LIST_FAILURE = 'FETCH_JOB_LIST_FAILURE';
export const RELOAD_JOB_LIST = 'RELOAD_JOB_LIST';
export const RESET_JOB_ITEMS = 'RESET_JOB_ITEMS';
export const SET_JOB_PAGE_INDEX = 'SET_JOB_PAGE_INDEX';
export const SET_JOB_PAGE_SIZE = 'SET_JOB_PAGE_SIZE';
export const SET_JOB_SEARCH = 'SET_JOB_SEARCH';
export const SET_JOB_SEARCH_KEY = 'SET_JOB_SEARCH_KEY';
export const SET_JOB_SORTING_DIRECTION = 'SET_JOB_SORTING_DIRECTION';
export const SET_JOB_SORTING_FIELD = 'SET_JOB_SORTING_FIELD';
export const SET_ACTIVE_APP_ID = 'SET_ACTIVE_APP_ID';
export const SET_JOB_LIST_SELECTED_VIEW = 'SET_JOB_LIST_SELECTED_VIEW';
